;(function(global, $) {
  /* @if env='production' **
  var MALL_SERVER = 'https://api-material.huariot.com/api-mall/api/v1'
  var BASE_SERVER = 'https://api-material.huariot.com/api-base/api/v1'
  var USER_SERVER = 'https://api-material.huariot.com/api-user/api/v1'
  /* @endif */
  /* @if env='testing' **
  var MALL_SERVER = 'http://test.portal.huariot.com/api-mall/api/v1'
  var BASE_SERVER = 'http://test.portal.huariot.com/api-base/api/v1'
  var USER_SERVER = 'http://test.portal.huariot.com/api-user/api/v1'
  /* @endif */
  /* @if env='development' **
  var MALL_SERVER = '/api-mall/api/v1'
  var BASE_SERVER = '/api-base/api/v1'
  var USER_SERVER = '/api-user/api/v1'
  /* @endif */

 
  // 地址分页列表
  function getAddress(callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/page-addresses/`
    }, callback)
  }

  // 新增地址
  function addAddress(condition, callback) {    
    return Fetch({
      url: `${MALL_SERVER}/mall/address/address/`,
      type: 'POST',
      data: JSON.stringify(condition)
    }, callback)
  }

  // 编辑地址
  function editAddress(condition, callback) {    
    return Fetch({
      url: `${MALL_SERVER}/mall/address/address/${condition.id}/`,
      type: 'PUT',
      data: JSON.stringify(condition)
    }, callback)
  }  


  // 删除地址
  function deleteAddress(id, callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/address/address/${id}/`,
      type: 'DELETE'
    }, callback)
  }

  // 设置是否默认地址
  function setDefault(condition, callback) {
    return Fetch({
      url: MALL_SERVER + '/mall/address/address-default/' + condition.id + '/',
      type: 'GET',
      data: {
        default_flag: condition.default_flag ? 1 : 0
      }
    }, callback)
  }
  
  /**
   * 生成订单
   * @param {[number]} address_id 地址id 
   * @param {[number]} delivery_type 配送方式
   * @param {[boolean]} invoice_flag 是否开票
   * @param {[array]} items 货品信息 sku_id,sku_quantity,remark
   * @param {[number]} order_channel 下单渠道 1-商城下单  2-官网下单
   * @param {[number]} pay_type 支付方式
   * @param {[string]} remark 备注
   */
  function generateOrder(condition, callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/office/order/`,
      type: 'POST',
      data: JSON.stringify(condition)      
    }, callback)
  }

  /**
   * 个人中心订单列表
   * @param {[number]} page 当前页
   * @param {[number]} pageSize 每页条目
   * @param {[string]} queryFiled 商品名称或订单编号 
   * @param {[number]} orderStatus  订单状态 0-全部 10-待支付 20-已支付 40-待发货 60-待收货  90-待评价 200-已完成 150-已取消
   */
  function getOrderlist(condition, callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/order/pages/`,
      type: 'GET',
      data: condition    
    }, callback)    
  }

  /**
   * 个人中心我的订单统计各状态下订单数量
   */
  function getOrderSummary(callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/order/summary/`,
      type: 'GET' 
    }, callback)    
  }  

  /**
   * 直接购买时确认订单展示商品信息
   * @param {{array}} proSkuIds sku_id sku_quantity
   */
  function purchaseDirect(condition, callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/order/product/`,
      type: 'POST',
      data: JSON.stringify(condition)      
    }, callback)    
  }

  /**
   * 取消订单
   * @param {[number]} orderId 订单id
   */
  function cancelOrder(orderId, callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/order/${orderId}/`,
      type: 'DELETE',   
    }, callback)    
  }

  /**
   * 生成支付宝支付申请
   * @param {[number]} orderId
   */
  function generatePay(orderId, callback) {
    return Fetch({
      url: `${MALL_SERVER}/mall/pay-apply/${orderId}/`,
      type: 'PUT',   
    }, callback)    
  }  

  global['MALL'] = {
    getAddress,
    addAddress,
    editAddress,
    deleteAddress,
    setDefault,
    generateOrder,
    getOrderlist,
    getOrderSummary,
    purchaseDirect,
    cancelOrder,
    generatePay
  }

}(window, window.jQuery))
